<!--
 * @Author: DY
 * @Date: 2025-03-03 17:37:22
 * @LastEditTime: 2025-03-18 17:41:42
 * @Description: 销售异议处理表单【销售管理-销售异议处理】
 * @FilePath: \ShiMo_Mobile\src\views\sales\salesObjectionHandling\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="salesObjectionHandlingForm commonFormStyles">
            <HeaderNav
                header-title="销售异议处理表单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <div class="formList">
                <van-collapse v-model="activeCollapseItem">
                    <van-collapse-item title="基本信息" name="1">
                        <van-field
                            disabled
                            label="异议处理单号"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                            v-model="formData.ObjectionNumber"
                        ></van-field>
                        <van-field
                            readonly
                            label="汽运单号"
                            placeholder="请选择汽运单号"
                            :disabled="isDisabled || openType == 'airWaybill'"
                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                            v-model="formData.TransportNumber"
                            @click="selectTransportNumber"
                        ></van-field>
                        <van-field
                            disabled
                            label="单据日期"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                            v-model="formData.ReceiptDate"
                        ></van-field>
                        <van-field
                            disabled
                            label="客户名称"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                            v-model="formData.ClientName"
                        ></van-field>
                        <van-field
                            disabled
                            label="进场皮重（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                            v-model="formData.DeliveryTareWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="出场毛重（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                            v-model="formData.DeliveryGrossWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="出场净重（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                            v-model="formData.DeliveryNetWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="发货数量（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                            v-model="formData.DeliveryWeight"
                        ></van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <template #title>
                            <span>卸货明细</span>
                        </template>
                        <van-field
                            disabled
                            label="进场皮重（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                            v-model="formData.UnloadTareWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="出场毛重（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                            v-model="formData.UnloadGrossWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="卸货净重（吨）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                            v-model="formData.UnloadNetWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="误差比（‰）"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_38@2x.png')"
                            v-model="formData.ErrorRatio"
                        ></van-field>
                        <van-field
                            disabled
                            label="到场签收处理意见说明"
                            placeholder="请选择汽运单号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            v-model="formData.SignOpinion"
                        ></van-field>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" @click="handleSubmit">
                        提交
                    </button>
                    <button class="confirm" @click="handleSave(null)">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import mixin_formSubmissionProcess from '@/components/processHandling/mixin/mixin_formSubmissionProcess';

export default {
    // 库位表单
    name: 'sales-objection-handling-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/salesObjectionHandling') {
            this.$store.commit('noKeepAlive', 'sales-objection-handling-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    mixins: [mixin_formSubmissionProcess],
    props: {},
    data() {
        return {
            isDisabled: false,
            activeCollapseItem: ['1', '2'],
            formData: {
                Id: '',
                ObjectionNumber: '',
                BusinessInstanceId: '',
                BusinessCode: '',
                DeliveryNoticeNumber: '',
                TransportNumber: '',
                ReceiptDate: '',
                ContractNo: '',
                ContractNumber: '',
                ClientId: '',
                ClientName: '',
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
                MaterialUnit: '',
                DeliveryTareWeight: 0,
                DeliveryGrossWeight: 0,
                DeliveryNetWeight: 0,
                DeliveryWeight: 0,
                UnloadTareWeight: 0,
                UnloadGrossWeight: 0,
                UnloadNetWeight: 0,
                ErrorRatio: 0,
                SignWeight: 0,
                ApproveStatus: 0,
                SignOpinion: '',
                TenantId: '',
            },
            businessCode: 'XS-YY-SH',
            openType: '',
            isSaveOperation: false,
            backPathName: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.isDisabled = true;
        }
        if (this.$route.params.collectNumber) {
            this.selectTransportNumberCallback(this.$route.params.collectNumber[0].transport_number);
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'salesObjectionHandling',
                params: {
                    isRefresh: this.isSaveOperation,
                },
            });
            this.$router.go(-1);
        },
        async initpage() {
            this.showOverlay = true;
            this.openType = this.$route.params.type;
            this.backPathName = this.$route.params.backPathName || 'salesObjectionHandling';
            if (this.openType === 'edit' || this.openType === 'view') {
                const id = this.$route.params.data.id;
                this.formData = await this.getFormDataRequrst(id);
            } else {
                this.getBusinessInstance();
            }
            if (this.openType === 'airWaybill') {
                this.selectTransportNumberCallback(this.$route.params.transport_number);
            }
            if (this.openType === 'view') {
                this.isDisabled = true;
            }
            this.showOverlay = false;
        },
        selectTransportNumber() {
            if (this.isDisabled || this.openType === 'edit') { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择汽运单',
                    sourcePath: 'salesObjectionHandlingForm',
                    listCode: 'delivery_objection_choose_transport_truck',
                    callbackDataKey: 'collectNumber',
                    // requestUrl: `/basicplatform/tabledata?delivery_notice_id=${this.formData.DeliveryNoticeId}`,
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '汽运单号',
                        code: 'transport_number',
                        isTitle: true,
                    }, {
                        name: '客户名称',
                        code: 'client_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_28@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '发货数量',
                        code: 'delivery_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '发货日期',
                        code: 'delivery_date',
                        icon: 'icon_7@2x',
                    }],
                },
            });
        },
        async selectTransportNumberCallback(transport_number) {
            this.showOverlay = true;
            const res = await this.getAirWaybillDetailsRequrst(transport_number);
            const Id = JSON.parse(JSON.stringify(this.formData.Id));
            const BusinessInstanceId = JSON.parse(JSON.stringify(this.formData.BusinessInstanceId));
            this.formData = Object.assign(this.formData, res, { Id, BusinessInstanceId });
            this.showOverlay = false;
        },
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'salesObjectionHandling',
            });
            this.$router.go(-1);
        },
        async handleSave(callBackFn) {
            const res = await this.saveFormRequrst(this.formData);
            if (res) {
                this.formData = res;
                this.formKeyValue = res.Id;
                if (this.openType === 'add' || this.openType === 'airWaybill') {
                    this.startBusinessInstance(callBackFn, this.formData);
                    this.openType = 'edit';
                    this.$toast('保存成功！');
                } else {
                    this.$toast('修改成功！');
                    this.getCurrentProcess(callBackFn);
                }
                this.isSaveOperation = true;
                if (!callBackFn) {
                    this.showOverlay = false;
                }
            }
        },
        getAirWaybillDetailsRequrst(transport_number) {
            return this.$axios.$get(`/interfaceApi/sale/delivery_objection/get_form_init_data/${transport_number}`);
        },
        getFormDataRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/delivery_objection/get_by_id/${id}`);
        },
        saveFormRequrst(requestData) {
            return this.$axios.$post('/interfaceApi/sale/delivery_objection/save', requestData);
        },
    },
};
</script>
<style lang="stylus">
.salesObjectionHandlingForm
    background #F0F0F0
</style>
